import {connectRouter} from 'connected-react-router';
import {combineReducers} from 'redux';
import {all} from 'redux-saga/effects';
import reduce from 'lodash-es/reduce';
import extend from 'lodash-es/extend';
import { languageReducer, languageSagas } from './language';
import { versionReducer, versionSagas } from './version';

import messagesReducer from './messages';

import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {jobsReducer, jobsSagas, jobsMessages} from "./jobs";
import {fileSagas, filesMessages, filesReducer} from "./files";
i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({});

const createReducers = (reducers, messages) => history =>
	combineReducers({
		// allow router access from state
		router: connectRouter(history),
		messages: messagesReducer([
			jobsMessages,
			filesMessages,
			...messages,
			// add messages reducers here
			({error, type}) =>
				error && {
					title: `Uncaught error for ${type}`,
					message: error.message,
					type: 'error'
				}
		]),
		language: languageReducer,
		version: versionReducer,
		jobs: jobsReducer,
		files: filesReducer,
		...reducers
	});

const createSagas = (sagas) => function* rootSaga() {
	yield all([
		...languageSagas,
		...versionSagas,
		...jobsSagas,
		...fileSagas,
		...sagas,
	]);
};

/**
 *
 * @param base
 * @param types
 * @returns {*} An object of types used in Saga
 * @example
 *

 import { createFetchTypes } from 'react-lib/dist/behavior-es';

 export default {
  ...createFetchTypes('app/groups/', {
    GET_GROUPS: 'GET',
    UPDATE_GROUP: 'PUT'
  })
};

 // same as :
 export default {
 		GET_GROUPS: "app/groups/GET",
		GET_GROUPS_FAILURE: "app/groups/GET/FAILURE",
		GET_GROUPS_SUCCESS: "app/groups/GET/SUCCESS",
		UPDATE_GROUP: "app/groups/PUT",
		UPDATE_GROUP_FAILURE: "app/groups/PUT/FAILURE",
		UPDATE_GROUP_SUCCESS: "app/groups/PUT/SUCCESS"
 };
 */
export const createFetchTypes = (base, types) => {
	return reduce(
		Object.keys(types)
			.map(key => ({
				[key]: base + types[key],
				[`${key}_SUCCESS`]: `${base + types[key]}/SUCCESS`,
				[`${key}_FAILURE`]: `${base + types[key]}/FAILURE`
			})),
		extend
	);
};

export * from './language';
export * from './files';

export default function register(reducers, messages, sagas) {
	return [createReducers(reducers, messages), createSagas(sagas)];
}
